export const SortDirection = {
    ASC: 'asc',
    DESC: 'desc'
}